import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosClientSignIn } from "../axios/api.js"
import { checkSession, logout, signIn } from "./authSlice";

export const activateMarket = createAsyncThunk(
  "market/activate",
  async (market, { rejectWithValue }) => {
    try {
      const response = await axiosClientSignIn.post("/api/market-access/activate", { market });
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message || error?.message || "Failed to activate market";
      return rejectWithValue(message);
    }
  }
);

const marketSlice = createSlice({
  name: "market",
  initialState: {
    activeMarket: null,
    allowed: [],
    status: "idle",
    error: null,
  },
  reducers: {
    setActiveMarketLocal: (state, action) => {
      state.activeMarket = action.payload || null;
    },
    setAllowedMarkets: (state, action) => {
      state.allowed = Array.isArray(action.payload) ? action.payload : [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(activateMarket.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(activateMarket.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.activeMarket = action.payload?.activeMarket || null;
        state.allowed = Array.isArray(action.payload?.allowed)
          ? action.payload.allowed
          : state.allowed;
      })
      .addCase(activateMarket.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to activate market";
      })

      .addCase(logout.fulfilled, (state) => {
        state.activeMarket = null;
        state.allowed = [];
        state.status = "idle";
        state.error = null;
      });
  },
});

export const { setActiveMarketLocal, setAllowedMarkets } = marketSlice.actions;
export default marketSlice.reducer;